export const messages = {
  editor: {
    title: {
      id: 'admin/promotions.form.restrictions.drawer.title',
    },
  },
  add: {
    id: 'admin/promotions.form.restrictions.add',
  },
  view: {
    items: {
      id: 'admin/promotions.form.restrictions.items',
    },
    quantity: {
      id: 'admin/promotions.form.restrictions.quantity',
    },
    maxUsage: {
      id: 'admin/promotions.form.restrictions.max-usage.view',
    },
    maxUsagePerClient: {
      id: 'admin/promotions.form.restrictions.max-usage-per-client.view',
    },
    maxItemsPerCart: {
      id: 'admin/promotions.form.restrictions.max-items-per-cart.view',
    },
    maxItemsPerAttribute: {
      id: 'admin/promotions.form.restrictions.max-items-per-attribute.view',
    },
    AppliedTo: {
      id: 'admin/promotions.form.restrictions.view.applied-to',
    },
  },
  validation: {
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
  },
}
